import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { getCountPage } from 'shared/libs/pagination/offset'

import { notificationsApi } from '../services/notifcationsApi'

import { NotificationState } from './types'

const initialState: NotificationState = {
  notifications: {},
  limit: 10,
  page: 1,
  count: 0,
  isUpdate: false,
}

export const NotificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    changeNotificationsParams: (
      state,
      {
        payload,
      }: PayloadAction<Partial<Omit<NotificationState, 'notifications'>>>,
    ) => {
      if (payload.limit) state.limit = payload.limit
      if (payload.page) state.page = payload.page
      state.isUpdate = payload.isUpdate ?? null
    },
    resetNofifications: () => {
      return initialState
    },
  },
  extraReducers: (build) => {
    build.addMatcher(
      notificationsApi.endpoints.notifications.matchFulfilled,
      (state, { payload, meta }) => {
        const { offset, limit } = meta.arg.originalArgs.params
        const currentPage = getCountPage({
          limit: (limit && +limit) || 10,
          count: (offset && +offset + 1) || 1,
        })
        state.count = payload.result.count ?? 0
        state.notifications = {
          ...((currentPage > 1 || state.isUpdate) && state.notifications),
          [String(currentPage)]: {
            results: payload.result.results,
            next: payload.result.next,
            previous: payload.result.previous,
          },
        }
        state.isUpdate = null
      },
    )
  },
})

export const { changeNotificationsParams, resetNofifications } =
  NotificationSlice.actions
export const notificationSlice = NotificationSlice.reducer
